// Canonical recipe tag colours — single source of truth for the entire app.
// Tags map to the `tags` jsonb column in the Supabase recipes table.
export const TAG_COLORS = {
  "high-protein":   "#C0392B",
  "quick":          "#E67E22",
  "budget":         "#2980B9",
  "under-500-kcal": "#27AE60",
};
